<template>
  <section class="finish">
    <section class="finish__header">
      <h1>{{ $t("password.password_reset") }}</h1>
      <span> {{ $t("password.your_password_reset") }} </span>
    </section>

    <v-btn
      class="border__radius-10 btn__default"
      color="primary"
      height="40"
      depressed
      block
      @click="backTo"
    >
      {{ $t("buttons.finalize") }}
    </v-btn>
  </section>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "PasswordFinishComponent",

  data: () => ({}),

  methods: {
    ...mapActions(["changeForDefaultPasswordConfig"]),

    backTo() {
      this.changeForDefaultPasswordConfig();
    },
  },
};
</script>

<style lang="scss" scoped>
.finish {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;

  .finish__header {
    display: flex;
    flex-direction: column;
    gap: 5px;
    text-align: center;

    h1 {
      text-align: center;
      font-weight: 600;
      font-size: 20px;
      color: #000000;
    }

    span {
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
  }
}
</style>
